import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=4a6af306&scoped=true&"
import script from "./VideoModal.vue?vue&type=script&lang=ts&"
export * from "./VideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=4a6af306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6af306",
  null
  
)

export default component.exports